import { io } from "socket.io-client";
import { getSocketUrl } from "./apiBase";

const socket = io(getSocketUrl(), {
  transports: ["websocket", "polling"],
  autoConnect: true,
});

export default socket;
